
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, StackBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DevOpsKPI_LeadTime() {

    const [title] = useState("Lead Time - DevOpsKPI")
    const [summary] =  useState("Key Performance Indicators of Software deployment and development in BD MMS for Lead Time.")
    const [categories] = useState(["MdLeaderboard","implementation"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [filterLayout] = useState([
        {column:"Column", field:"column_name"},
        {column:"Filter Value", field: "value_name"},
        {column:"Product Type",field:"producttype"}
    ])
    const [revLayout] = useState([
        {column:"Grouping Value", field:"grouping"},
        {column:"Result", field: "value_name"}
    ])
    const [tfsLayout] = useState([
        {column:"Established TFS Value", field:"tfsValue"}
    ])

    const [bubbleColor, setBubColor] = useState(null)
    const [bubbleColorClosed, setBubColorClosed] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColor(new Map([
            ["Scheduled_with_permission", "#4e79a7"],
            ["Customer_Managed", "#f28e2c"],
            ["Scheduled_wo_permission", "#59a14f"]
          ]))
          setBubColorClosed(new Map([
            ["Closed", "#FFA500"],
            ["Open", "#4169E1"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/DevOpsKPI_LeadTime/DevOpsKPI_LeadTime.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        Lead time measures the total time it takes for work to move through the value stream, from the moment the work is requested to the time it is delivered.
                        </p>
                        <p>
                         <a href="/DevOpsKPI">Devops KPIs</a>
                         </p>

                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                               <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Jenkins Recorded Start and PMO Recorded End Time Delta
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBuildDate}
                            axis = {{y:"# of Days"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Recorded time from first run in artifactory to recorded feature complete by MMS PMO.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Jenkins Build Time Associated to Artifactory
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedLastYearByMonthBuildTime}
                            axis = {{y:"# of Minutes"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Jenkins run build times linked to projects in artifactory.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Production Issue Count for the last year from TFS
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackePI}
                            axis = {{y:"Code Added"}}
                            tooltip={"Org:"}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of Production Issue in TFS based on Davinci.
                            </Typography>
                    </div>
                </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Production Issue Count for the last year from TFS Normalized
                             </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedPI100}
                            axis = {{y:"Code Added"}}
                            tooltip={""}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of Production Issue in TFS based on Davinci normalized out of 100.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Task Count for the last year from TFS
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackeTask}
                            axis = {{y:"Code Added"}}
                            tooltip={"Org:"}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of Task in TFS based on Davinci.
                            </Typography>
                    </div>
                </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Task Count for the last year from TFS Normalized
                             </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedTask100}
                            axis = {{y:"Code Added"}}
                            tooltip={""}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of Task in TFS based on Davinci normalized out of 100.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Bug Count for the last year from TFS
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackeBug}
                            axis = {{y:"Code Added"}}
                            tooltip={"Org:"}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of Bug in TFS based on Davinci.
                            </Typography>
                    </div>
                </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Bug Count for the last year from TFS Normalized
                             </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBug100}
                            axis = {{y:"Code Added"}}
                            tooltip={""}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of Bug in TFS based on Davinci normalized out of 100.
                            </Typography>
                    </div>
                </Paper>





            </div >
        )
    }
}

export default DevOpsKPI_LeadTime